export const CREATE_LISTING_STEP = 'create-listing';
export const EDIT_LISTING_STEP = 'edit-listing';
export const VEHICLE_DETAILS_STEP = 'vehicle-details';
export const LIST_PRICE_STEP = 'set-list-price';
export const PHOTO_UPLOADER_STEP = 'upload-photos';
export const SELLER_INFO_STEP = 'seller-info';
export const PREVIEW_STEP = 'preview';

export const CREATE = 'create';
export const EDIT = 'edit';

export const PAGE_NAMES = {
  [CREATE_LISTING_STEP]: 'private_party_create_listing',
  [EDIT_LISTING_STEP]: 'private_party_edit_listing',
  [VEHICLE_DETAILS_STEP]: 'private_party_create_listing_vehicle_details',
  [LIST_PRICE_STEP]: 'private_party_create_listing_price',
  [PHOTO_UPLOADER_STEP]: 'private_party_create_listing_photos',
  [SELLER_INFO_STEP]: 'private_party_create_listing_seller',
  [PREVIEW_STEP]: 'private_party_create_listing_preview',
};

export const PRIVATE_PARTY_PAGE_CATEGORY = 'private_party';

export const CREATE_LISTING_STEP_DATA = {
  name: 'Car Details',
  mobileName: 'Your Car Details',
  path: '',
  nextPath: VEHICLE_DETAILS_STEP,

  showNextBtn: true,
};

export const EDIT_LISTING_STEP_DATA = {
  ...CREATE_LISTING_STEP_DATA,
};

export const VEHICLE_DETAILS_STEP_DATA = {
  name: 'Car Details',
  mobileName: 'Your Car Details',
  path: VEHICLE_DETAILS_STEP,
  prevPath: CREATE_LISTING_STEP,
  nextPath: LIST_PRICE_STEP,
  order: 1,

  showNextBtn: true,
  showVehicleSummary: true,
};
export const EDIT_VEHICLE_DETAILS_STEP_DATA = {
  ...VEHICLE_DETAILS_STEP_DATA,
  prevPath: EDIT_LISTING_STEP,
};
export const LIST_PRICE_STEP_DATA = {
  name: 'Selling Price',
  mobileName: 'Set Your Selling Price',
  path: LIST_PRICE_STEP,
  prevPath: VEHICLE_DETAILS_STEP,
  nextPath: PHOTO_UPLOADER_STEP,
  order: 2,

  showBackBtn: true,
  showNextBtn: true,
  showVehicleSummary: true,
  showLocation: true,
};
export const EDIT_LIST_PRICE_STEP_DATA = {
  ...LIST_PRICE_STEP_DATA,
  name: 'Listing Price',
  mobileName: 'Set Your Listing Price',
};
export const PHOTO_UPLOADER_STEP_DATA = {
  name: 'Photos',
  mobileName: 'Upload Photos',
  path: PHOTO_UPLOADER_STEP,
  prevPath: LIST_PRICE_STEP,
  nextPath: SELLER_INFO_STEP,
  order: 3,

  showBackBtn: true,
  showNextBtn: true,
  showVehicleSummary: true,
  showLocation: true,
};
export const EDIT_PHOTO_UPLOADER_STEP_DATA = {
  ...PHOTO_UPLOADER_STEP_DATA,
  nextPath: PREVIEW_STEP,
};
export const SELLER_INFO_STEP_DATA = {
  name: 'Your Info',
  mobileName: 'Your Information',
  path: SELLER_INFO_STEP,
  prevPath: PHOTO_UPLOADER_STEP,
  nextPath: PREVIEW_STEP,
  order: 4,

  showBackBtn: true,
  showNextBtn: true,
  showVehicleSummary: true,
  showLocation: true,
};
export const PREVIEW_STEP_DATA = {
  name: 'Review',
  mobileName: 'Review & Submit Your Listing',
  path: PREVIEW_STEP,
  prevPath: SELLER_INFO_STEP,
  nextPath: '',
  order: 5,

  showBackBtn: true,
};
export const EDIT_PREVIEW_STEP_DATA = {
  ...PREVIEW_STEP_DATA,
  mobileName: 'Review & Submit',
  prevPath: PHOTO_UPLOADER_STEP,
  order: 3,
};

export const STEPS = [
  VEHICLE_DETAILS_STEP_DATA,
  LIST_PRICE_STEP_DATA,
  PHOTO_UPLOADER_STEP_DATA,
  SELLER_INFO_STEP_DATA,
  PREVIEW_STEP_DATA,
];

export const EDIT_STEPS = [
  EDIT_VEHICLE_DETAILS_STEP_DATA,
  EDIT_LIST_PRICE_STEP_DATA,
  EDIT_PHOTO_UPLOADER_STEP_DATA,
  EDIT_PREVIEW_STEP_DATA,
];

export const STEPS_MAP = {
  [CREATE_LISTING_STEP]: CREATE_LISTING_STEP_DATA,
  [VEHICLE_DETAILS_STEP]: VEHICLE_DETAILS_STEP_DATA,
  [LIST_PRICE_STEP]: LIST_PRICE_STEP_DATA,
  [PHOTO_UPLOADER_STEP]: PHOTO_UPLOADER_STEP_DATA,
  [SELLER_INFO_STEP]: SELLER_INFO_STEP_DATA,
  [PREVIEW_STEP]: PREVIEW_STEP_DATA,
};

export const EDIT_STEPS_MAP = {
  [EDIT_LISTING_STEP]: EDIT_LISTING_STEP_DATA,
  [VEHICLE_DETAILS_STEP]: EDIT_VEHICLE_DETAILS_STEP_DATA,
  [LIST_PRICE_STEP]: EDIT_LIST_PRICE_STEP_DATA,
  [PHOTO_UPLOADER_STEP]: EDIT_PHOTO_UPLOADER_STEP_DATA,
  [PREVIEW_STEP]: EDIT_PREVIEW_STEP_DATA,
};

export const COLORS_AND_OPTIONS_STEP = 'colors_and_options';
export const CONDITION_AND_MILEAGE_STEP = 'condition_and_mileage';
export const PARTNER_OFFER_CONDITIONS_STEP = 'partner_offer_conditions';

export const COLORS_AND_OPTIONS_STEP_DATA = {
  title: 'Color and Options',
  id: 'colors-and-options',
};
export const CONDITION_AND_MILEAGE_STEP_DATA = {
  title: 'Condition and Mileage',
  id: 'condition-and-mileage',
};
export const PARTNER_OFFER_CONDITIONS_STEP_DATA = {
  title: 'Condition Questions',
  id: 'partner-offer-conditions',
};

export const COLORS_SECTION_DATA = {
  sellerNotesTitle: "Add Seller's Notes",
  disclaimerText: 'Please do not include any personal information such as name, email or phone.',
};

export const VEHICLE_DETAILS_STEPS_MAP = {
  [COLORS_AND_OPTIONS_STEP]: COLORS_AND_OPTIONS_STEP_DATA,
  [CONDITION_AND_MILEAGE_STEP]: CONDITION_AND_MILEAGE_STEP_DATA,
  [PARTNER_OFFER_CONDITIONS_STEP]: PARTNER_OFFER_CONDITIONS_STEP_DATA,
};

export const VEHICLE_DETAILS_STEPS_PP_ICO = [
  COLORS_AND_OPTIONS_STEP,
  CONDITION_AND_MILEAGE_STEP,
  PARTNER_OFFER_CONDITIONS_STEP,
];

export const VEHICLE_DETAILS_STEPS = [COLORS_AND_OPTIONS_STEP, CONDITION_AND_MILEAGE_STEP];
